import { BankOperationStatusesNew } from 'constants/bankOperationStatusesNew';
import { Role } from 'constants/roles';

import { usePermissions } from 'hooks/usePermissions';
import { BankOperation } from 'types/embedded/bankOperation';

type useRequestsBankOpsEditableReturnValues = {
  isEdit: (record?: BankOperation) => boolean;
  isDelete: (record?: BankOperation) => boolean;
  isFileEdit: (record?: BankOperation) => boolean;
  isAccessAgreement: (record?: BankOperation) => boolean;
};

export function useRequestsBankOpsEditable(): useRequestsBankOpsEditableReturnValues {
  const { isHaveRole } = usePermissions();

  const isHaveStatus = (record: BankOperation, status: string) => {
    return record?.status.value === status;
  };

  if (isHaveRole([Role.Finance])) {
    return {
      isEdit: (record?: BankOperation): boolean => {
        if (!record) {
          return false;
        }
        return (
          isHaveStatus(record, BankOperationStatusesNew.Created) ||
          isHaveStatus(record, BankOperationStatusesNew.Rejected)
        );
      },
      isDelete: (record?: BankOperation): boolean => {
        if (!record) {
          return false;
        }

        return (
          isHaveStatus(record, BankOperationStatusesNew.Created) ||
          isHaveStatus(record, BankOperationStatusesNew.Rejected)
        );
      },
      isFileEdit: (record?: BankOperation): boolean => {
        if (!record) {
          return false;
        }

        return (
          isHaveStatus(record, BankOperationStatusesNew.Created) ||
          isHaveStatus(record, BankOperationStatusesNew.Rejected)
        );
      },
      isAccessAgreement: (record?: BankOperation): boolean => {
        if (!record) {
          return false;
        }
        return (
          isHaveStatus(record, BankOperationStatusesNew.Created) ||
          isHaveStatus(record, BankOperationStatusesNew.Rejected)
        );
      },
    };
  }

  if (isHaveRole([Role.FinanceLead])) {
    return {
      isEdit: (record?: BankOperation): boolean => {
        if (!record) {
          return false;
        }
        return (
          isHaveStatus(record, BankOperationStatusesNew.OnApproval) ||
          isHaveStatus(record, BankOperationStatusesNew.Created) ||
          isHaveStatus(record, BankOperationStatusesNew.Rejected)
        );
      },
      isDelete: (record?: BankOperation): boolean => {
        if (!record) {
          return false;
        }

        return (
          isHaveStatus(record, BankOperationStatusesNew.Created) ||
          isHaveStatus(record, BankOperationStatusesNew.Rejected)
        );
      },
      isFileEdit: (record?: BankOperation): boolean => {
        if (!record) {
          return false;
        }

        return (
          isHaveStatus(record, BankOperationStatusesNew.Created) ||
          isHaveStatus(record, BankOperationStatusesNew.Rejected)
        );
      },
      isAccessAgreement: (record?: BankOperation): boolean => {
        if (!record) {
          return false;
        }
        return (
          isHaveStatus(record, BankOperationStatusesNew.Created) ||
          isHaveStatus(record, BankOperationStatusesNew.Rejected)
        );
      },
    };
  }

  if (isHaveRole([Role.Admin])) {
    return {
      isEdit: (record?: BankOperation): boolean => {
        if (!record) {
          return false;
        }
        return (
          isHaveStatus(record, BankOperationStatusesNew.OnApproval) ||
          isHaveStatus(record, BankOperationStatusesNew.Created) ||
          isHaveStatus(record, BankOperationStatusesNew.Rejected)
        );
      },
      isDelete: (record?: BankOperation): boolean => {
        if (!record) {
          return false;
        }

        return (
          isHaveStatus(record, BankOperationStatusesNew.Created) ||
          isHaveStatus(record, BankOperationStatusesNew.Rejected)
        );
      },
      isFileEdit: (record?: BankOperation): boolean => {
        if (!record) {
          return false;
        }

        return !isHaveStatus(record, BankOperationStatusesNew.OnApproval);
      },
      isAccessAgreement: (): boolean => {
        return true;
      },
    };
  }

  return {
    isEdit: () => false,
    isDelete: () => false,
    isFileEdit: () => false,
    isAccessAgreement: () => false,
  };
}
